/**
 * 浏览器指纹工具类，用于收集浏览器特征并生成唯一标识
 */

/**
 * 浏览器指纹工具类
 */
class BrowserFingerprint {
  /**
   * 生成简单哈希值
   * @param {string} str 输入字符串
   * @returns {string} 哈希值
   */
  simpleHash(str) {
    let hash = 0;
    for (let i = 0; i < str.length; i++) {
      const char = str.charCodeAt(i);
      hash = ((hash << 5) - hash) + char;
      hash = hash & hash; // 转换为32位整数
    }
    return Math.abs(hash).toString(16);
  }

  /**
   * 获取Canvas指纹
   * @returns {string} Canvas指纹字符串
   */
  getCanvasFingerprint() {
    try {
      const canvas = document.createElement('canvas');
      const ctx = canvas.getContext('2d');
      if (!ctx) return 'canvas_not_supported';

      // 在画布上绘制一些内容
      ctx.fillStyle = 'rgb(255, 255, 255)';
      ctx.fillRect(0, 0, canvas.width, canvas.height);
      ctx.font = '24px Arial';
      ctx.fillStyle = 'rgb(0, 0, 0)';
      ctx.fillText('Browser Fingerprint', 10, 30);
      ctx.fillStyle = 'rgba(0, 0, 255, 0.5)';
      ctx.fillRect(10, 50, 100, 50);

      // 返回画布的dataURL作为指纹
      return canvas.toDataURL();
    } catch (e) {
      return 'canvas_not_supported';
    }
  }

  /**
   * 获取WebGL指纹
   * @returns {string} WebGL指纹字符串
   */
  getWebGLFingerprint() {
    try {
      const canvas = document.createElement('canvas');
      const gl = canvas.getContext('webgl') || canvas.getContext('experimental-webgl');
      if (!gl) return 'webgl_not_supported';

      // 获取WebGL参数
      const renderer = gl.getParameter(gl.RENDERER);
      const vendor = gl.getParameter(gl.VENDOR);
      const version = gl.getParameter(gl.VERSION);

      return `${renderer}|${vendor}|${version}`;
    } catch (e) {
      return 'webgl_not_supported';
    }
  }

  /**
   * 获取浏览器特征信息
   * @returns {Object} 浏览器特征对象
   */
  getBrowserFeatures() {
    return {
      // 浏览器基本信息
      appName: navigator.appName,
      userAgent: navigator.userAgent,
      platform: navigator.platform,
      product: navigator.product,

      // 硬件信息
      hardwareConcurrency: navigator.hardwareConcurrency,
      deviceMemory: navigator.deviceMemory || 'unknown',

      // 屏幕信息
      pixelDepth: screen.pixelDepth,
      colorDepth: screen.colorDepth,
      screenResolution: `${screen.width}x${screen.height}`,

      // 系统信息
      timezoneOffset: new Date().getTimezoneOffset(),

      // 高级指纹
      canvasFingerprint: this.getCanvasFingerprint(),
      webGLFingerprint: this.getWebGLFingerprint()
    };
  }

  /**
   * 获取浏览器指纹
   * @returns {Object} 包含指纹和特征信息的对象
   */
  getFingerprint() {
    const features = this.getBrowserFeatures();
    const featureString = JSON.stringify(features);
    const fingerprint = this.simpleHash(featureString);

    return {
      fingerprint,
      features
    };
  }
}

// 导出实例和类
const browserFingerprint = new BrowserFingerprint();

export default browserFingerprint;



// WEBPACK FOOTER //
// ./src/util/browserFingerprint.js